<template>
    <div class="project-list bg-white" id="project_sidebar_container">
        <div class="position-sti bg-white z-index-6 project__list-sticky">
        <div class="searchBox px-010rem blue cursor-default border-bottom-serach" id="projectrightside_driver" v-if="!showArchivedProjects">
            <img v-if="clientWidth <= 1300" :src="sidebarArrowIcon" alt="sidebarArrowIcon" class="cursor-pointer mr-1" @click="$emit('close')">
            <div class="form-control d-flex" style="border-color: #D2D2D2; height: 30px; padding: 0px 16px;">
                <input type="text" v-model="search" :placeholder="$t('PlaceHolder.search')" ref="projectSearchInput" id="projectrightsidesearch_driver" class="serach-inputbox webkit-avilable ml-0" @input="updateSearch">

                <div class="d-flex align-items-center">
                    <DropDown id="project_filter_options" class="project_filter_options" :title="$t('ProjectSlider.project_search_filter')">
                        <template #button>
                            <img :src="horizontalDots" alt="horizontalDots" class="vertical-middle" id="projectrightsidedropdown_driver">
                        </template>
                        <template #options>
                            <DropDownOption @click="setProjectSearch">
                                <span class="project-mobile-desc mr-10px">{{ $t('ProjectSlider.project_name') }}</span>
                                <Toggle :modelValue="projectSearch" :disabled="projectSearch" @click="setProjectSearch" class="filter-toggle" width="20"
                                />
                            </DropDownOption>
                            <DropDownOption @click="setFolderSearch">
                                <span class="project-mobile-desc mr-10px">{{ $t('ProjectSlider.folder_name') }}</span>
                                <Toggle :modelValue="folderSearch" :disabled="folderSearch" @click="setFolderSearch" class="filter-toggle" width="20" />
                            </DropDownOption>
                            <DropDownOption @click="setSprintSearch">
                                <span class="project-mobile-desc mr-10px">{{ $t('ProjectSlider.sprint_name') }}</span>
                                <Toggle :modelValue="sprintSearch" :disabled="sprintSearch" @click="setSprintSearch" class="filter-toggle" width="20" />
                            </DropDownOption>
                        </template>
                    </DropDown>
                </div>
            </div>
            <ProjectFilter :projectData="projectData" @apply="applyFilter" @clear="$emit('clearFilter')" v-if="Object.keys(projectData).length > 0"/>
        </div>
        <div class="searchBox px-010rem blue border-bottom-serach cursor-pointer hideArchived_text" id="projectrightside_driver" v-else>
            <div class="d-flex align-items-center">
                <img v-if="clientWidth <= 1300" :src="sidebarArrowIcon" alt="sidebarArrowIcon" class="cursor-pointer mr-1" @click="$emit('close')">
                <div class="black">{{$t('ProjectSlider.archived_list')}}</div>
            </div>
            <div @click="$emit('update:showArchivedProjects', false)">{{$t('ProjectSlider.hide_archive')}}</div>
        </div>
        <div class="bg-white position-sti d-flex align-items-center justify-content-between p-10px assignee__drop-wrapper" v-if="!showArchivedProjects">
            <div class="d-flex align-items-center">
                <img id="projestleftlistfilter_driver" :src="filterFavorites ? starImage : blankStar" alt="starImage" class="cursor-pointer fillstar__image" @click="emit('update:filterFavorites', !filterFavorites)" v-show="!search && ProjectfilterObject?.query && !Object.keys(ProjectfilterObject?.query).length && !Object.keys(ProjectfilterObject?.sortByField).length && !Object.keys(ProjectfilterObject?.sortByOrder).length"/>
            </div>
            <div class="d-flex align-items-center">
                <DropDown>
                    <template #button>
                        <img ref="project_show_hide" :src="settingIcon" alt="settingIcon" class="cursor-pointer vertical-middle" id="projectleftsidsetting_driver"/>
                    </template>
                    <template #options>
                        <DropDownOption @click="$refs.project_show_hide.click(), $emit('update:showArchivedProjects', true)">
                            {{$t('ProjectSlider.show_archive')}}
                        </DropDownOption>
                    </template>
                </DropDown>
                <!-- <button v-if="!showArchivedProjects && checkPermission('project.project_list',projectData?.isGlobalPermission) === true && checkPermission('project.project_create',projectData.isGlobalPermission) === true" class="outline-primary ml-1 font-size-16 p0x-13px" @click="tourTest('isProjectTour'), $emit('createProject')" id="createproject_driver">+ {{$t('ProjectSlider.new_project')}}</button> -->
            </div>
        </div>
        </div>
        <!-- <div :class="[{'showArchived_space' : showArchivedProjects}]"> -->
            <template v-if="!loader && !isSpinner">
                <template v-if="displayProjects?.length">
                    <div class="style-scroll" style="height: calc(100% - 104px); overflow-y: auto;">
                            <Item
                                v-for="item in displayProjects"
                                v-model:expands="expands"
                                :key="item._id"
                                :item="item"
                                :filterFavorites="filterFavorites"
                                :selected="projectData !== null && projectData._id === item._id"
                                @toggle="(data) => {mutateCurrentProjectDetails(data,true,true);$emit('projectDataClick'); expands.project = expandedId}"
                                @change="(data) => {(projectData !== null && projectData._id === item._id ? mutateCurrentProjectDetails(data, true) : mutateCurrentProjectDetails(data,true));$emit('projectDataClick')}"
                                @changeAvatar="$emit('changeAvatar', $event)"
                                @projectAction="projectAction"
                                @archiveCountChange="(delta) => emit('archiveCountChange', delta)"
                                :loadingData="loadingData[item._id]"
                                :sprintData="(search === '' || projectSearch || (isProjectFilterApplied && search !== '' && !projectSearch)) ? sprintFolders: (item.sprintData || {})"
                                :isExpanded="item._id === expandedId || (search !== '' && (folderSearch || sprintSearch))"
                                @handleSidebarClose="$emit('handleSidebarClose')"
                                :isShowArchived="showArchivedProjects"
                            />
                    </div>
                </template>
                <template v-else>
                    <div class="text-center mt-1">
                        <h3 class="m-0">
                            {{!search?.length ? (isSpinner === false && projects.length == 0 ? $t('ProjectSlider.no_project_found') : $t('ProjectSlider.no_result_found')) : $t('ProjectSlider.no_result_found')}}
                        </h3>
                        <p v-if="search?.length" class="font-size-14 mt-10px">{{$t('ProjectSlider.try_using_diff')}}</p>
                    </div>
                </template>
            </template>
            <template v-else>
                <div v-for="i in 2" :key="i">
                    <div class="d-flex flex-column align-items-end">
                        <Skelaton class="border-radius-5-px mr-5px my-2px h-35px w-95"/>
                        <Skelaton class="border-radius-5-px mr-5px my-2px h-35px w-90"/>
                        <Skelaton class="border-radius-5-px mr-5px my-2px h-35px w-85"/>
                        <Skelaton class="border-radius-5-px mr-5px my-2px h-35px w-90"/>
                        <Skelaton class="border-radius-5-px mr-5px my-2px h-35px w-90"/>
                    </div>
                </div>
            </template>
        <!-- </div> -->
    </div>
</template>

<script setup>
import Item from '@/components/organisms/Item/Item.vue'
import DropDown from '@/components/molecules/DropDown/DropDown.vue'
import DropDownOption from '@/components/molecules/DropDownOption/DropDownOption.vue'
import ProjectFilter from '@/components/molecules/ProjectFilter/ProjectFilter.vue'
import Toggle from '@/components/atom/Toggle/Toggle.vue'
import Skelaton from "@/components/atom/Skelaton/Skelaton.vue"
import { useStore } from 'vuex';
import { useCustomComposable } from '@/composable';
import { inject, onMounted, ref, watch, computed } from 'vue'
import { useProjectsHelper } from '../../../views/Projects/helper'
import { apiRequest } from '../../../services'
import * as env from '@/config/env';

// IMAGES
const horizontalDots = require("@/assets/images/svg/horizontalDots.svg");
const sidebarArrowIcon = require("@/assets/images/svg/sidebarclose_arrow.svg");
const starImage = require("@/assets/images/svg/start16.svg");
const blankStar = require("@/assets/images/svg/blankStar.svg");
const settingIcon = require("@/assets/images/svg/setting_vector.svg");

const {commit, getters} = useStore();
const userId = inject("$userId");
const clientWidth = inject("$clientWidth");
const {projects, filterdProjects,projectListFilters} = useProjectsHelper();
const searchProject = computed(()=> getters['projectData/searchedProjects'])
const {debounce} = useCustomComposable()

const emit = defineEmits(["loadMoreProjects","applyFilter","update:search","updateSearchProject","update:searchData", "update:loader","projectDataClick","handleSidebarClose","createProject", "archiveCountChange"]);
const props = defineProps({
    showArchivedProjects: {
        type: Boolean,
        required: true,
        default: false
    },
    filterFavorites: {
        type: Boolean,
        default: false
    },
    projectData: {
        type: Object,
        required: true
    },
    ProjectfilterObject: {
        type: Object,
        required: true
    },
    loader: {
        type: Boolean,
        required: true
    },
    isSpinner: {
        type: Boolean,
        required: true
    },
    loadedProjects: {
        type: Array,
        required: true
    },
    projectItems: {
        type: Array,
        default: null
    },
    loadingData: {
        type: Object,
        required: true
    },
    mutateCurrentProjectDetails : {
        type: Function,
        required: true
    },
    expandedId: {
        type: String,
        required: true
    },
    sprintFolders: {
        type: Object,
        required: true
    },
    isProjectFilterApplied: {
        type:Boolean,
        required:true
    },
    isSearchAPIWait: {
        type:Boolean,
        required:true
    }
})

// const sprintFolderData = ref(props.sprintFolders)
const search = ref("");
const expands = ref({
    project: null,
    folder: null
});
const projectSearchInput = ref(null);
const projectSearch = ref(true);
const folderSearch = ref(false);
const sprintSearch = ref(false);
const isSearchAPIWaiting = ref(props.isSearchAPIWait)
const displayProjects = computed(() => Array.isArray(props.projectItems) ? props.projectItems : filterdProjects.value);

function focusSearch() {
    projectSearchInput.value?.focus();
}



onMounted(() => {
    emit("update:loader", false);
})

// watch(filterdProjects, () => {
//     emit("loadMoreProjects")
// },{deep: true});


watch(() => props.isSearchAPIWait, (newVal) => {
    isSearchAPIWaiting.value = newVal;
})

// SEARCH OPERATION ON PROJECTS
watch(() => [search.value, projects.value, () => props.filterFavorites, projectSearch.value, folderSearch.value, sprintSearch.value,props.isProjectFilterApplied, searchProject.value], debounce((newValues,oldValues) => {
    /* eslint-disable */
    if (Array.isArray(props.projectItems)) {
        return;
    }
    let isProjectFilterApplied = props.isProjectFilterApplied;

    const [newSearch, newProjects, newFilterFavorites, newProjectSearch, newFolderSearch, newSprintSearch,newProjectFilterApplied, newSearchProject] = newValues;
    const [oldSearch, oldProjects, oldFilterFavorites, oldProjectSearch, oldFolderSearch, oldSprintSearch,olProjectFIlterApplied, oldSearchProject] = oldValues;
    let isSearchUpdate;
    if (newSearch !== oldSearch || newProjectSearch !== oldProjectSearch || newFolderSearch !== oldFolderSearch || newSprintSearch !== oldSprintSearch || newProjectFilterApplied !== olProjectFIlterApplied) {
        isSearchUpdate = true;
    } else {
        isSearchUpdate = false;
    }

    if (newSearch !== oldSearch && newSearch === '' && isProjectFilterApplied) {
        reApplyFilter();
    }
    projectListFilters({
        projectSearch,
        folderSearch,
        sprintSearch,
        filterFavorites: props.filterFavorites,
        search,
        showArchivedProjects: props.showArchivedProjects,
        isSearchUpdate:isSearchUpdate,
        isProjectFilterApplied,
        ProjectfilterObject: props.ProjectfilterObject
    }).then(() => {
        if(!isSearchAPIWaiting.value){
            emit("update:loader", false);
        }
    })
    .catch((error) => {
        console.error("ERROR", error)
        emit("update:loader", false);
    })
    emit("update:searchData",newSearch);
}, 300));


const reApplyFilter = () => {
    let obj = {
        type: "projectFilter",
        ...props.ProjectfilterObject
    }
    let isProjectFilterApplied = props.isProjectFilterApplied
    apiRequest("post", `${env.PROJECTSEARCH}`, obj).then((serachedData)=>{

        commit("projectData/mutateSearchedProjects", { data: serachedData?.data || [], searchType: "projectFilter" });
        projectListFilters({
            projectSearch,
            folderSearch,
            sprintSearch,
            filterFavorites: props.filterFavorites,
            search:search.value,
            showArchivedProjects: props.showArchivedProjects,
            isSearchUpdate:false,
            isProjectFilterApplied,
            ProjectfilterObject: props.ProjectfilterObject
        })
        .catch((error) => {
            console.error("ERROR", error)
        })
    }).catch((error)=>{
        console.error(error)
    })
}

const projectAction = (itemData,key,subKey) => {
    commit('projectData/projectLocalUpdate', {itemData,key,subKey,userId: userId.value});
    if (key === 'MarkAsFavourite') {
        syncFavouriteStateInDisplayedProjects(itemData, subKey);
    }
    if(props.showArchivedProjects){
        const index = filterdProjects.value.findIndex(x => x._id === itemData._id);
        filterdProjects.value.splice(index,1);
    }
}

function getNextFavouriteTasks(favouriteTasks = [], subKey = "") {
    const currentFavouriteTasks = Array.isArray(favouriteTasks) ? [...favouriteTasks] : [];

    if (subKey === "add") {
        return currentFavouriteTasks.some((x) => x.userId === userId.value)
            ? currentFavouriteTasks
            : [...currentFavouriteTasks, { userId: userId.value }];
    }

    return currentFavouriteTasks.filter((x) => x.userId !== userId.value);
}

function syncFavouriteStateInDisplayedProjects(itemData = {}, subKey = "") {
    const index = filterdProjects.value.findIndex((project) => project._id === itemData._id);
    if (index === -1) return;

    const project = filterdProjects.value[index];
    filterdProjects.value.splice(index, 1, {
        ...project,
        favouriteTasks: getNextFavouriteTasks(project.favouriteTasks, subKey),
    });
}

function applyFilter (query, sortByField, sortByOrder){
    emit('applyFilter',query, sortByField, sortByOrder)
}

function updateSearch() {
  emit('update:search', search.value);
}
function setProjectSearch() {
  projectSearch.value = true;
  folderSearch.value = false;
  sprintSearch.value = false;
  emitSearch();
}

function setFolderSearch() {
  folderSearch.value = true;
  projectSearch.value = false;
  sprintSearch.value = false;
  emitSearch();
}

function setSprintSearch() {
  sprintSearch.value = true;
  projectSearch.value = false;
  folderSearch.value = false;
  emitSearch();
}

function emitSearch() {
  emit('updateSearchProject', {
    projectSearch: projectSearch.value,
    folderSearch: folderSearch.value,
    sprintSearch: sprintSearch.value,
  });
}

defineExpose({
    focusSearch
})
</script>
